import React from 'react';
import Skeleton from '../spending/ClaimsSkeleton';
import { Row, Col } from 'react-bootstrap';

const CarouselSkeleton = () => (
  <div className="skeleton-container">
    <Row className=" mr-0">
      {Array(4)
        .fill()
        .map((ele, i) => {
          return (
            <Col key={i} xs={6} md={6} className="p-2">
              <Skeleton />
            </Col>
          );
        })}
    </Row>
  </div>
);

export default CarouselSkeleton;
